// components/Skeletons.js
import React from 'react';

export const ContactSelectorSkeleton = () => (
  <div className="skeleton-container">
    <h2>Sélectionner un contact (Lead)</h2>
    <div className="skeleton-select">
      <div className="skeleton-line"></div>
    </div>
  </div>
);

export const AccountResultsSkeleton = () => (
  <div className="skeleton-container">
    <h2>Contacts similaires signés</h2>
    <div className="skeleton-table">
      <div className="skeleton-table-header">
        <div className="skeleton-line short"></div>
        <div className="skeleton-line medium"></div>
        <div className="skeleton-line short"></div>
        <div className="skeleton-line long"></div>
        <div className="skeleton-line short"></div>
      </div>
      {Array.from({ length: 5 }).map((_, index) => (
        <div key={index} className="skeleton-table-row">
          <div className="skeleton-line short"></div>
          <div className="skeleton-line medium"></div>
          <div className="skeleton-line short"></div>
          <div className="skeleton-line long"></div>
          <div className="skeleton-line short"></div>
        </div>
      ))}
    </div>
  </div>
);